"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClassesRefreshSelector = exports.classesRefreshSelector = exports.useClassesIsLoadingSelector = exports.classesIsLoadingSelector = exports.useClassesSelector = exports.classesSelector = exports.taxonomyClassesSelector = void 0;
const react_redux_1 = require("react-redux");
const reselect_1 = require("reselect");
const main_1 = require("./main");
exports.taxonomyClassesSelector = (0, reselect_1.createSelector)(main_1.enrichSelector, ({ taxonomyClasses }) => taxonomyClasses);
exports.classesSelector = (0, reselect_1.createSelector)(exports.taxonomyClassesSelector, ({ classes }) => classes);
const useClassesSelector = () => (0, react_redux_1.useSelector)(exports.classesSelector);
exports.useClassesSelector = useClassesSelector;
exports.classesIsLoadingSelector = (0, reselect_1.createSelector)(exports.taxonomyClassesSelector, ({ isLoading }) => isLoading);
const useClassesIsLoadingSelector = () => (0, react_redux_1.useSelector)(exports.classesIsLoadingSelector);
exports.useClassesIsLoadingSelector = useClassesIsLoadingSelector;
exports.classesRefreshSelector = (0, reselect_1.createSelector)(exports.taxonomyClassesSelector, ({ isRefresh }) => isRefresh);
const useClassesRefreshSelector = () => (0, react_redux_1.useSelector)(exports.classesRefreshSelector);
exports.useClassesRefreshSelector = useClassesRefreshSelector;
